<template>
  <div class="consulta-wrapper">

    <!-- ── Header compacto (sin Layout completo, es popup) ──────── -->
    <div class="consulta-header d-flex align-items-center justify-content-between px-3 py-2">
      <div class="d-flex align-items-center gap-2">
        <span class="material-symbols-outlined text-white" style="font-size:22px">assignment</span>
        <span class="text-white fw-bold" style="font-size:1rem">
          Planilla N.° {{ planilla.numero || idPlanilla }}
        </span>
      </div>
      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-sm btn-outline-light" @click="exportarExcel" title="Exportar Excel"
          :disabled="!planilla.idPlanilla">
          <span class="material-symbols-outlined" style="font-size:16px;vertical-align:middle">table_view</span>
          Excel
        </button>
        <button class="btn btn-sm btn-outline-light" @click="imprimirPagina" title="Imprimir">
          <span class="material-symbols-outlined" style="font-size:16px;vertical-align:middle">print</span>
        </button>
        <button class="btn btn-sm btn-outline-light" @click="cerrarVentana" title="Cerrar">
          <span class="material-symbols-outlined" style="font-size:16px;vertical-align:middle">close</span>
        </button>
      </div>
    </div>

    <!-- ── Spinner ────────────────────────────────────────────────── -->
    <div v-if="cargando" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
      <p class="text-muted mt-2 small">Cargando planilla...</p>
    </div>

    <!-- ── Error ──────────────────────────────────────────────────── -->
    <div v-else-if="error" class="alert alert-danger m-3">
      <span class="material-symbols-outlined align-middle me-1">error</span>
      {{ error }}
    </div>

    <!-- ── Contenido ──────────────────────────────────────────────── -->
    <div v-else-if="planilla.idPlanilla" class="consulta-body px-3 py-2">

      <!-- ── Información general ──────────────────────────────────── -->
      <div class="section-card mb-3">
        <div class="section-title">
          <span class="material-symbols-outlined">person</span>
          Información General
        </div>
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">Trámite</span>
            <span class="info-value">{{ planilla.idTramite }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">N.° Planilla</span>
            <span class="info-value fw-bold">{{ planilla.numero }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Cédula Paciente</span>
            <span class="info-value">{{ planilla.cedula }}</span>
          </div>
          <div class="info-item info-item--wide">
            <span class="info-label">Nombre Paciente</span>
            <span class="info-value fw-bold">{{ planilla.nombre }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Cédula Médico</span>
            <span class="info-value">{{ planilla.cedulaMedico }}</span>
          </div>
          <div class="info-item info-item--wide">
            <span class="info-label">Nombre Médico</span>
            <span class="info-value">{{ planilla.nombreMedico }}</span>
          </div>
        </div>
      </div>

      <!-- ── Periodo de atención ───────────────────────────────────── -->
      <div class="section-card mb-3">
        <div class="section-title">
          <span class="material-symbols-outlined">calendar_month</span>
          Periodo de Atención
        </div>
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">Fecha Desde</span>
            <span class="info-value">{{ fmtFecha(planilla.fechaDesde) }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Fecha Hasta</span>
            <span class="info-value">{{ fmtFecha(planilla.fechaHasta) }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Hora Desde</span>
            <span class="info-value">{{ planilla.horaDesde }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Hora Hasta</span>
            <span class="info-value">{{ planilla.horaHasta }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Estado AM</span>
            <span class="badge" :class="badgeEstado(planilla.estadoAud)">{{ planilla.estadoAud }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Estado GD</span>
            <span class="badge" :class="badgeEstado(planilla.estadoDoc)">{{ planilla.estadoDoc }}</span>
          </div>
        </div>
      </div>

      <!-- ── Diagnósticos ──────────────────────────────────────────── -->
      <div class="section-card mb-3">
        <div class="section-title">
          <span class="material-symbols-outlined">diagnosis</span>
          Diagnósticos
        </div>
        <div class="info-grid">
<div class="info-item" v-for="d in diagnosticos" :key="d.label">
  <span class="info-label">{{ d.label }}</span>
  <span class="info-value font-monospace">{{ d.valor }}</span>
</div>
          <div v-if="!tieneDiagnosticos" class="text-muted small">
            Sin diagnósticos registrados.
          </div>
        </div>
      </div>

      <!-- ── Detalles ──────────────────────────────────────────────── -->
      <div class="section-card mb-3">
        <div class="section-title d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center gap-1">
            <span class="material-symbols-outlined">list_alt</span>
            Detalles de la Planilla
            <span class="badge bg-secondary ms-1">{{ detallesFiltrados.length }}</span>
          </div>
          <!-- Filtro y paginación inline -->
          <div class="d-flex align-items-center gap-2">
            <div class="filter-input-wrap">
              <span class="material-symbols-outlined filter-icon">search</span>
              <input
                type="text"
                class="filter-input"
                v-model="filtroDetalles"
                placeholder="Filtrar detalles..."
                @input="paginarDetalles(1)"
              />
              <button v-if="filtroDetalles" class="filter-clear"
                @click="filtroDetalles = ''; paginarDetalles(1)">
                <span class="material-symbols-outlined" style="font-size:14px">close</span>
              </button>
            </div>
            <select v-model.number="elementosPorPagina" class="form-select form-select-sm"
              style="width:70px" @change="paginarDetalles(1)">
              <option :value="10">10</option>
              <option :value="25">25</option>
              <option :value="50">50</option>
              <option :value="999999">Todos</option>
            </select>
          </div>
        </div>

        <!-- Spinner detalles -->
        <div v-if="cargandoDetalles" class="text-center py-3">
          <div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
          <span class="small text-muted ms-2">Cargando detalles...</span>
        </div>

        <div v-else-if="detalles.length === 0" class="alert alert-warning mb-0 mt-2 py-2 small">
          No hay detalles registrados para esta planilla.
        </div>

        <div v-else class="table-responsive mt-2">
          <table class="table table-hover table-bordered table-sm mb-1">
            <thead class="table-dark">
              <tr>
                <th class="th-sort" @click="ordenarPor('fechaAtencion')">
                  F. Atención <span class="sort-icon">{{ iconOrden('fechaAtencion') }}</span>
                </th>
                <th class="th-sort" @click="ordenarPor('elementoCodigo')">
                  Código <span class="sort-icon">{{ iconOrden('elementoCodigo') }}</span>
                </th>
                <th class="th-sort" @click="ordenarPor('elementoNombre')">
                  Elemento TPSNS <span class="sort-icon">{{ iconOrden('elementoNombre') }}</span>
                </th>
                <th class="th-sort" @click="ordenarPor('codigo')">
                  Cód. Prestador <span class="sort-icon">{{ iconOrden('codigo') }}</span>
                </th>
                <th class="th-sort" @click="ordenarPor('descripcion')">
                  Desc. Prestador <span class="sort-icon">{{ iconOrden('descripcion') }}</span>
                </th>
                <th class="th-sort text-end" @click="ordenarPor('cantidad')">
                  Cantidad <span class="sort-icon">{{ iconOrden('cantidad') }}</span>
                </th>
                <th class="th-sort text-end" @click="ordenarPor('valorUni')">
                  Val. Unitario <span class="sort-icon">{{ iconOrden('valorUni') }}</span>
                </th>
                <th class="text-end">Val. Total</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="d in detallesPaginados"
                :key="d.idPlanillaDet"
                :class="{ 'table-warning': d.revisado == 1 }"
              >
                <td style="white-space:nowrap">{{ fmtFecha(d.fechaAtencion) }}</td>
                <td class="font-monospace">{{ d.elementoCodigo }}</td>
                <td>{{ d.elementoNombre }}</td>
                <td class="font-monospace">{{ d.codigo }}</td>
                <td>{{ d.descripcion }}</td>
                <td class="text-end">{{ d.cantidad }}</td>
                <td class="text-end">{{ fmtNum(d.valorUni) }}</td>
                <td class="text-end fw-bold">{{ fmtNum(d.cantidad * d.valorUni) }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="table-secondary fw-bold">
                <td colspan="5" class="text-end small">TOTAL</td>
                <td class="text-end small">{{ sumaCantidad }}</td>
                <td></td>
                <td class="text-end small">{{ fmtNum(sumaTotal) }}</td>
              </tr>
            </tfoot>
          </table>

          <!-- Paginación detalles -->
          <div class="d-flex justify-content-between align-items-center mt-1"
            v-if="totalPaginasDetalles > 1">
            <span class="small text-muted">
              Página {{ paginaActual }} de {{ totalPaginasDetalles }} —
              {{ detallesFiltrados.length }} registros
            </span>
            <nav>
              <ul class="pagination pagination-sm mb-0">
                <li class="page-item" :class="{ disabled: paginaActual === 1 }">
                  <a class="page-link" href="#" @click.prevent="paginarDetalles(1)">«</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaActual === 1 }">
                  <a class="page-link" href="#" @click.prevent="paginarDetalles(paginaActual - 1)">‹</a>
                </li>
                <li v-for="pag in paginasVisibles" :key="pag" class="page-item"
                  :class="{ active: pag === paginaActual, disabled: pag === '...' }">
                  <a class="page-link" href="#"
                    @click.prevent="pag !== '...' && paginarDetalles(pag)">{{ pag }}</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaActual === totalPaginasDetalles }">
                  <a class="page-link" href="#" @click.prevent="paginarDetalles(paginaActual + 1)">›</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaActual === totalPaginasDetalles }">
                  <a class="page-link" href="#"
                    @click.prevent="paginarDetalles(totalPaginasDetalles)">»</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api  from "@/services/api";
import * as XLSX from "xlsx";

export default {
  name: "PlanillaConsulta",

  // Recibe idPlanilla como parámetro de ruta: /planilla-consulta/:idPlanilla
  props: {
    idPlanilla: { type: [Number, String], required: true },
  },

  data() {
    return {
      // ── Planilla ──────────────────────────────────────────────
      planilla:        {},
      cargando:        false,
      error:           "",

      // ── Detalles ──────────────────────────────────────────────
      detalles:        [],
      detallesPaginados: [],
      cargandoDetalles: false,
      paginaActual:    1,
      elementosPorPagina: 25,
      filtroDetalles:  "",
      campoOrden:      "fechaAtencion",
      ascendente:      false,
    };
  },

  computed: {
    tieneDiagnosticos() {
      return [1,2,3,4,5].some(i => this.planilla["diag" + i]);
    },

    // ── Detalles filtrados y ordenados ─────────────────────────
    detallesFiltrados() {
      const texto = this.filtroDetalles.toLowerCase().trim();
      let lista = this.detalles;
      if (texto) {
        lista = lista.filter(d =>
          [d.elementoCodigo, d.elementoNombre, d.codigo, d.descripcion]
            .some(v => (v ?? "").toString().toLowerCase().includes(texto))
        );
      }
      const campo = this.campoOrden;
      const numCampos = ["cantidad", "valorUni", "valorTotal", "revisado"];
      return [...lista].sort((a, b) => {
        let va = a[campo] ?? "";
        let vb = b[campo] ?? "";
        const cmp = numCampos.includes(campo)
          ? Number(va) - Number(vb)
          : String(va).localeCompare(String(vb), "es");
        return this.ascendente ? cmp : -cmp;
      });
    },

    totalPaginasDetalles() {
      if (this.elementosPorPagina >= 999999) return 1;
      return Math.max(1, Math.ceil(this.detallesFiltrados.length / this.elementosPorPagina));
    },

    paginasVisibles() {
      const total  = this.totalPaginasDetalles;
      const actual = this.paginaActual;
      const delta  = 2;
      const rango  = [];
      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) {
        rango.push(i);
      }
      if (rango.length && rango[0] > 2)                         rango.unshift("...");
      if (rango.length && rango[rango.length - 1] < total - 1)  rango.push("...");
      const paginas = [1];
      rango.forEach(p => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },

    // ── Totales ────────────────────────────────────────────────
    sumaCantidad() {
      return this.detallesFiltrados.reduce((acc, d) => acc + (Number(d.cantidad) || 0), 0);
    },

    sumaTotal() {
      return this.detallesFiltrados.reduce(
        (acc, d) => acc + (Number(d.cantidad) || 0) * (Number(d.valorUni) || 0),
        0
      );
    },
  },

  async mounted() {
    await this.cargarPlanilla();
    await this.cargarDetalles();
    // Título de la ventana popup
    document.title = `Planilla ${this.planilla.numero || this.idPlanilla}`;
  },

  methods: {
    // ── Carga de datos ────────────────────────────────────────
    async cargarPlanilla() {
      this.cargando = true;
      this.error    = "";
      try {
        const r      = await api.get(`/vwplanillas/${this.idPlanilla}`);
        this.planilla = r.data;
      } catch {
        this.error = "No se pudo cargar la planilla. Verifique el ID e intente de nuevo.";
      } finally {
        this.cargando = false;
      }
    },

    async cargarDetalles() {
      this.cargandoDetalles = true;
      try {
        const r      = await api.get(`/vwplanilladets/idplanilla-estado/${this.idPlanilla}/1`);
        this.detalles = r.data ?? [];
        this.paginarDetalles(1);
      } catch {
        this.detalles = [];
      } finally {
        this.cargandoDetalles = false;
      }
    },

    // ── Paginación ────────────────────────────────────────────
    paginarDetalles(n) {
      this.paginaActual = Math.max(1, Math.min(n, this.totalPaginasDetalles));
      if (this.elementosPorPagina >= 999999) {
        this.detallesPaginados = this.detallesFiltrados;
        return;
      }
      const ini              = (this.paginaActual - 1) * this.elementosPorPagina;
      this.detallesPaginados = this.detallesFiltrados.slice(ini, ini + this.elementosPorPagina);
    },

    // ── Ordenamiento ──────────────────────────────────────────
    ordenarPor(campo) {
      if (this.campoOrden === campo) {
        this.ascendente = !this.ascendente;
      } else {
        this.campoOrden = campo;
        this.ascendente = true;
      }
      this.paginarDetalles(1);
    },

    iconOrden(campo) {
      if (this.campoOrden !== campo) return "⇅";
      return this.ascendente ? "↑" : "↓";
    },

    // ── Badge estado ──────────────────────────────────────────
    badgeEstado(estado) {
      return {
        "bg-warning text-dark": estado === "PENDIENTE",
        "bg-success":           estado === "REVISADA",
        "bg-primary":           estado === "FINALIZADA",
        "bg-secondary":         !["PENDIENTE", "REVISADA", "FINALIZADA"].includes(estado),
      };
    },

    // ── Utilidades ────────────────────────────────────────────
    fmtFecha(fecha) {
      if (!fecha) return "";
      return new Date(fecha).toLocaleDateString("es-EC", {
        day: "2-digit", month: "2-digit", year: "numeric",
      });
    },

    fmtNum(valor) {
      return new Intl.NumberFormat("es-EC", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(valor || 0);
    },

    cerrarVentana() {
      window.close();
    },

    imprimirPagina() {
      window.print();
    },

    // ── Exportar Excel ────────────────────────────────────────
    exportarExcel() {
      const p = this.planilla;

      // Hoja 1: Info planilla
      const infoPlanilla = [
        ["Campo", "Valor"],
        ["Trámite",          p.idTramite],
        ["N.° Planilla",     p.numero],
        ["Cédula Paciente",  p.cedula],
        ["Nombre Paciente",  p.nombre],
        ["Cédula Médico",    p.cedulaMedico],
        ["Nombre Médico",    p.nombreMedico],
        ["Fecha Desde",      this.fmtFecha(p.fechaDesde)],
        ["Fecha Hasta",      this.fmtFecha(p.fechaHasta)],
        ["Hora Desde",       p.horaDesde],
        ["Hora Hasta",       p.horaHasta],
        ["Estado AM",        p.estadoAud],
        ["Estado GD",        p.estadoDoc],
        ["Diag 1",           p.diag1],
        ["Diag 2",           p.diag2],
        ["Diag 3",           p.diag3],
        ["Diag 4",           p.diag4],
        ["Diag 5",           p.diag5],
      ];

      // Hoja 2: Detalles
      const headersDetalles = [
        "F. Atención", "Código TPSNS", "Elemento TPSNS",
        "Cód. Prestador", "Desc. Prestador",
        "Cantidad", "Val. Unitario", "Val. Total", "Revisado",
      ];
      const filasDetalles = this.detallesFiltrados.map(d => [
        this.fmtFecha(d.fechaAtencion),
        d.elementoCodigo,
        d.elementoNombre,
        d.codigo,
        d.descripcion,
        d.cantidad,
        d.valorUni,
        (d.cantidad * d.valorUni).toFixed(2),
        d.revisado == 1 ? "Sí" : "No",
      ]);
      // Fila de totales
      filasDetalles.push([
        "TOTAL", "", "", "", "",
        this.sumaCantidad, "", this.sumaTotal.toFixed(2), "",
      ]);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(infoPlanilla),   "Planilla");
      XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet([headersDetalles, ...filasDetalles]), "Detalles");
      XLSX.writeFile(wb, `planilla_${p.numero || this.idPlanilla}.xlsx`);
    },
  },
};
</script>

<style scoped>
/* ── Layout general ──────────────────────────────────────────── */
.consulta-wrapper {
  min-height: 100vh;
  background: #f8f9fa;
  font-size: 0.875rem;
}

/* ── Header ──────────────────────────────────────────────────── */
.consulta-header {
  background: linear-gradient(135deg, #1a3a5c 0%, #2563a8 100%);
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0,0,0,.2);
}

/* ── Secciones ───────────────────────────────────────────────── */
.section-card {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
}
.section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  font-size: 0.9rem;
  color: #1a3a5c;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 8px;
  margin-bottom: 12px;
}
.section-title .material-symbols-outlined { font-size: 18px; color: #2563a8; }

/* ── Grid info ───────────────────────────────────────────────── */
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 8px 16px;
}
.info-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.info-item--wide {
  grid-column: span 2;
}
.info-label {
  font-size: 0.7rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: .04em;
  font-weight: 600;
}
.info-value {
  font-size: 0.875rem;
  color: #212529;
  word-break: break-word;
}

/* ── Tabla ───────────────────────────────────────────────────── */
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover { background-color: #3d5166; }
.sort-icon     { font-size: 0.7rem; opacity: 0.8; }
.table-hover tbody tr { cursor: default; }

/* ── Filtro ──────────────────────────────────────────────────── */
.filter-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.filter-icon {
  position: absolute;
  left: 7px;
  font-size: 16px !important;
  color: #6c757d;
  pointer-events: none;
}
.filter-input {
  padding: 4px 28px 4px 28px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 0.8rem;
  width: 180px;
  outline: none;
}
.filter-input:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 2px rgba(13,110,253,.15);
}
.filter-clear {
  position: absolute;
  right: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: #6c757d;
  display: flex;
  align-items: center;
}
.filter-clear:hover { color: #dc3545; }

/* ── Impresión ───────────────────────────────────────────────── */
@media print {
  .consulta-header .btn { display: none !important; }
  .filter-input-wrap    { display: none !important; }
  .pagination           { display: none !important; }
  select                { display: none !important; }
  .section-card         { box-shadow: none; border: 1px solid #ccc; }
}
</style>